import { datetime } from '@/util'

export const carStateDisplay = (d) => {
  if (d.enableState == 0) {
    return '未启用'
  } else if (d.enableState == 2) {
    return '禁用'
  } else if (d.lockState == 1) {
    return '锁定'
  } else if (d.startState == 1) {
    return '行驶中'
  } else {
    return '正常'
  }
}

export const carStateIcon = (d) => {
  if (d.enableState == 0) {
    return 'default'
  } 
  else if (d.enableState == 2) {
    return 'error'
  } 
  else if (d.lockState == 1) {
    return 'warning'
  }
  else if (d.startState == 1) {
    return 'processing'
  }
  else{
    return 'success'
  }
}

export const billingRuleDisplay = (d) => {
  if (d.buyOptions == 0) {
    return 'n/a'
  } else {
    if (d.billing && d.billing) {
      return ''
    } else {
      return 'n/a'
    }
  }
}

export const lastBindRecordDisplay = (d) => {
  if (d && d.lastBilling && d.lastBilling.tradeDatetime) {
    return datetime(d.lastBilling.tradeDatetime)
  } else {
    return ''
  }
}

export const buyOptionsDisplay = (d) => {
  if(d.billing){
    if(d['billing.buyOptions'] == 0){
      return '全款'
    }
    else if(d['billing.buyOptions'] == 1){
      if(d['billing.clearingType'] && d['billing.stagesPrice'] && d['billing.stagesNum']){
        return `分期（${d['billing.clearingTypeText']} ${d['billing.stagesPrice'].toFixed(2)} x ${d['billing.stagesNum']}期）`
      }else{
        return '分期'
      }
    }
  }else{
    return 'n/a'
  }
}

export const balanceDisplay = (d) => {
  return d['billing.balance'] || 'n/a'
}

export const lockStateDisplay = (d) => {
  if (d.lastLockRecord.lockerType) {
    return d.lockStateText + `(${d.lastLockRecord.lockerTypeText})`
  } else {
    return d.lockStateText
  }
}

export const courierNameDisplay = (d) => {
  if (d.courier && d.courier.name) {
    return d.courier.name
  } else {
    return 'n/a'
  }
}

const valueToV = (v , step = 25) => {
  if (v >= 0 && v <= 100) {
    return Math.ceil(v / step)
  } else {
    return 0
  }
}

export const carStatusConv = (d) => {
  d.heartbeatLastTimeText = d.heartbeatLastTime ? datetime(d.heartbeatLastTime) : 'n/a'
  if (d.carBattery !== null) {
    d.carBatteryValue = valueToV(d.carBattery)
    d.carBatteryDisplay = `${d.carBattery}%`
  } else {
    d.carBatteryValue = 0
    d.carBatteryDisplay = 'n/a'
  }

  if (d.gsmWaft !== null) {
    d.gsmWaftValue = d.gsmWaft
    d.gsmWaftDisplay = ['无信号','极弱','较弱','良好','强'][d.gsmWaft]
  } else {
    d.gsmWaftValue = 0
    d.gsmWaftDisplay = '无信号'
  }

  if (d.satelliteWaft !== null) {
    d.satelliteWaftDisplay = d.satelliteWaft
  }else{
    d.satelliteWaftDisplay = 'n/a'
  }

}

export const carLocationConv = (d) => {
  if(!d.location) d.location = {}
  d.recordDatetimeText = d.recordDatetime ? datetime(d.recordDatetime) : 'n/a'
}
export const onlineStatusDisplay = (d) => {
  return d.status && d.status.onlineStatus == 1 ? '在线' : '离线'
}

export const carBatteryDisplay = (d) => {
  return d.status && d.status.carBattery !== null ? `${d.status.carBattery}%` : 'n/a'
}

export const carNoRange = (d) => {
  return `${d.carNoStart} - ${d.carNoEnd}`
}
export const companyDisplay = (d) => {
  let name = d.company ? d.company.companyName : ""
  // if(name.length>8){
  //   name = name.substring(0,6) + '...'
  // }
  return name
  //d.company ? (d.company.shortName || d.company.companyName) : ""
}